type ProhibitionLengthCounts = {
	monthsCount: number;
	daysCount: number;
};

export const getProhibitionLengthCounts = (
	value?: string
): ProhibitionLengthCounts => {
	const defaultCounts = (): ProhibitionLengthCounts => ({
		monthsCount: 0,
		daysCount: 0,
	});

	if (typeof value !== 'string') {
		return defaultCounts();
	}

	const normalized = value.trim();
	if (!normalized) {
		return defaultCounts();
	}

	const units = Array.from(normalized.matchAll(/(\d+)\s*([md])/gi));
	if (units.length === 0) {
		return defaultCounts();
	}

	return units.reduce<ProhibitionLengthCounts>((result, [, amount, unit]) => {
		const numericAmount = parseInt(amount, 10);

		if (Number.isNaN(numericAmount)) {
			return result;
		}

		return unit.toLowerCase() === 'm'
			? { ...result, monthsCount: result.monthsCount + numericAmount }
			: { ...result, daysCount: result.daysCount + numericAmount };
	}, defaultCounts());
};
